module.exports = __webpack_public_path__ + "static/media/tanque-gris_old.6a4bfd95.svg";